import {
  isRequired,
  isNumber,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ name }) => isRequired(name) || { name: 'Additional charges name is required. ' },
  ({ price }) => isNumber(price) || { price: 'Price should be a valid number.' },
];

const KEYS = [
  'name',
  'price',
];

export {
  validations,
  KEYS,
};
